import { useSearch } from '@tanstack/react-router'

import { AuthLayout } from '../_components/auth-layout'
import { ForgotPasswordForm } from './_components/forgot-password-form'

const ForgotPasswordPage = () => {
  const searchParams = useSearch({ strict: false }) as { email?: string }
  return (
    <AuthLayout>
      <ForgotPasswordForm defaultEmailValue={searchParams?.email} />
    </AuthLayout>
  )
}

export default ForgotPasswordPage
